var _a, _b, _c;
import { createBreakpoints, createColors } from "../theme";
import { BackgroundType } from "../components/Background";
var TeamInfos = {
    first: {
        name: "blue",
        main: "#266287",
        lightBG: "#C1D0DA",
        mediumBG: "#8FB0C4",
        darkBG: "#1B4670", // Background for Leaderboard Row
    },
    second: {
        name: "green",
        main: "#396A43",
        lightBG: "#d9e3da",
        mediumBG: "#cddbc5",
        darkBG: "#516D56",
    },
    third: {
        name: "orange",
        main: "#DD7C36",
        lightBG: "#E6D9D4",
        mediumBG: "#E9C8BA",
        darkBG: "#7C4749",
    },
    fourth: {
        name: "purple",
        main: "#591B5A",
        lightBG: "#CEC9D5",
        mediumBG: "#AD97B2",
        darkBG: "#591B5A",
    }
};
export var classic = {
    host: {
        create: {
            errorColor: "#F44336",
        },
        game: {
            pauseColor: "#F44336",
        },
    },
    welcome: {
        welcomeText: { color: "white" },
        subtitle: {
            color: "#92C7F0"
        },
        instructions: {
            instructionBorder: "1px solid #92C7F0",
            small: {
                src: "/assets/instructions/classic/instructions-small.png",
                countdown: {
                    label: {
                        top: -1,
                        left: 116,
                    },
                    text: {
                        top: 5,
                        left: 10
                    }
                },
                submit: {
                    label: {
                        top: 118,
                        left: 98
                    },
                    text: {
                        top: 131,
                        left: 10
                    }
                }
            },
            other: {
                countdown: {
                    label: {
                        top: 14,
                        left: 401,
                    },
                    text: {
                        top: 31,
                        left: 0,
                    }
                },
                submit: {
                    label: {
                        top: 224,
                        left: 243
                    },
                    text: {
                        top: 249,
                    }
                }
            },
            large: {
                src: "/assets/instructions/classic/instructions-large.png",
                countdown: {
                    label: {
                        top: 14,
                        left: 229
                    },
                    text: {
                        top: 6,
                        left: 0,
                    }
                },
                submit: {
                    label: {
                        top: 124,
                        left: 135
                    },
                    text: {
                        top: 128,
                    }
                }
            },
        },
        actionButton: {
            border: "1px solid white",
            textTransform: "uppercase",
            color: "white",
        },
    },
    background: {
        backgroundImage: {
            large: (_a = {},
                _a[BackgroundType.Welcome] = "url('/assets/backgrounds/classic/bg-large-welcome.svg')",
                _a[BackgroundType.GetStarted] = "url('/assets/backgrounds/classic/bg-large-main.svg')",
                _a[BackgroundType.Main] = "url('/assets/backgrounds/classic/bg-large-main.svg')",
                _a[BackgroundType.ThankYou] = "url('/assets/backgrounds/classic/bg-large-thankyou.svg')",
                _a),
            small: (_b = {},
                _b[BackgroundType.Welcome] = "url('/assets/backgrounds/classic/bg-small-welcome.svg')",
                _b[BackgroundType.GetStarted] = "url('/assets/backgrounds/classic/bg-small-main.svg')",
                _b[BackgroundType.Main] = "url('/assets/backgrounds/classic/bg-small-main.svg')",
                _b[BackgroundType.ThankYou] = "url('/assets/backgrounds/classic/bg-small-thankyou.svg')",
                _b),
        },
        backgroundColor: (_c = {},
            _c[BackgroundType.Welcome] = "#071931",
            _c[BackgroundType.GetStarted] = "#071931",
            _c[BackgroundType.Main] = "#071931",
            _c[BackgroundType.ThankYou] = "#071931",
            _c)
    },
    questionPrompt: {
        background: "rgba(1,43,69,0.63)",
        timerColor: "#E1E9F1",
        timeRemainderColor: "#2AD1D1"
    },
    questionExplanation: {
        backgroundColor: "#0F355478"
    },
    multipleChoice: {
        multipleChoiceColors: {
            first: "#115284",
            second: "#0378CD",
            third: "#785ECB",
            fourth: "#0C7D91",
            disabled: "#868686"
        },
        feedbackColor: "#FFCC32"
    },
    phrase: {
        foregroundColor: "lightgray",
        foregroundFocusColor: "darkgray"
    },
    questionSubmit: {
        border: "2px solid #E1DAE5",
        borderRadius: 24,
        background: "transparent linear-gradient(72deg, #15B57B 0%, #2AD1D1 100%) 0% 0% no-repeat padding-box;",
        icon: {
            color: "white",
            backgroundColor: "#0F3B5B"
        },
        foreground: "#0F3B5B"
    },
    questionProgress: {
        pastBox: {
            backgroundColor: "rgba(0, 24, 46, 0.45)",
        },
        currentBox: {
            backgroundColor: "#2AD1D1",
        }
    },
    gameComplete: {
        decorativeCircles: true,
        thankYouTextColor: "#74729A",
        background: "transparent linear-gradient(180deg, #392E5E 0%, #161F40 100%) 0% 0% no-repeat padding-box"
    },
    presenterVideo: {
        background: "#032954",
        muteBackground: "#2ACFCF",
        textBackground: "#2ACFCF",
    },
    chat: {
        inputBorder: "1px solid darkgray",
        scrollBar: "#562E70",
        background: {
            focused: "#0c1124",
            unfocused: "#0c1124aa"
        },
        nicknameFontWeight: 400,
        colorDark: "#544890",
        colorLight: "#B5B2CE",
        sendButton: {
            background: "#562E70"
        }
    },
    teamInfos: TeamInfos,
    accessoryPanel: {
        background: "transparent linear-gradient(180deg, #392E5E 0%, #161F40 100%) 0% 0% no-repeat padding-box",
        expandButton: {
            desktop: {
                chevron: {
                    src: "/assets/accessory/common/expand-desktop.png",
                    srcSet: "/assets/accessory/common/expand-desktop.png, /assets/accessory/common/expand-desktop@2x.png 2x"
                },
                chevronWarning: {
                    src: "/assets/accessory/classic/expand-desktop-glow.png",
                    srcSet: "/assets/accessory/classic/expand-desktop-glow.png, /assets/accessory/classic/expand-desktop-glow@2x.png 2x"
                }
            },
            mobile: {
                expand: {
                    src: "/assets/accessory/classic/expand-mobile.png",
                    srcSet: "/assets/accessory/classic/expand-mobile.png, /assets/accessory/classic/expand-mobile@2x.png 2x"
                },
                expandGlow: {
                    src: "/assets/accessory/classic/expand-mobile-glow.png",
                    srcSet: "/assets/accessory/classic/expand-mobile-glow.png, /assets/accessory/classic/expand-mobile-glow@2x.png 2x"
                }
            }
        },
        tabs: {
            background: "transparent linear-gradient(0deg, #33366A 0%, #1F1446 100%) 0% 0% no-repeat padding-box",
            leaderboardIcon: "/assets/icons/classic/leaderboard.svg",
            chatIcon: "/assets/icons/classic/chat.svg",
            dashboardIcon: "/assets/icons/classic/dashboard.svg",
            tabSelector: "1px solid #5275F2",
        },
        participantCounter: "rectangle",
        leaderboard: {
            teamAverage: {
                color: "white"
            },
            rankChange: {
                up: "#6af022",
                down: "#ff6969"
            },
            row: {
                borderWidth: 1,
                rankedStreakSVG: "/assets/leaderboard/common/hot-streak.svg",
                unrankedStreakSVG: "/assets/leaderboard/common/hot-streak.svg",
                currentPlayer: {
                    borderWidth: "1px 0 1px 1px",
                    borderColor: "#99EFEF",
                    unrankedColor: "#99EFEF",
                    rankedColor: "#99EFEF",
                    rankChangeUnrankedColor: "#99EFEF",
                    rankChangeRankedColor: "#99EFEF",
                    team: {
                        borderColor: "#99EFEF",
                        rankChangeUnrankedColor: "#99EFEF",
                        rankChangeRankedColor: "#99EFEF",
                        unrankedColor: "#99EFEF",
                        rankedColor: "#99EFEF",
                    },
                },
                regularPlayer: {
                    rankedColor: "white",
                    unrankedColor: "white",
                    team: {
                        rankedColor: "white",
                        unrankedColor: "white",
                    },
                },
            },
            scorePill: {
                showBorder: true
            },
            rank: {
                showBorder: true
            },
            firstPlace: {
                backgroundColor: "#DD57574D",
                highlightColor: "#DD5757",
                borderColor: "#F2606767"
            },
            secondPlace: {
                backgroundColor: "#FF82254D",
                highlightColor: "#FF8225",
                borderColor: "#FF9B504D"
            },
            thirdPlace: {
                backgroundColor: "#FFCC324D",
                highlightColor: "#FFCC32",
                borderColor: "#FFCC324D"
            },
            default: {
                borderColor: "#585858BA",
                backgroundColor: "#04304BBA",
            }
        },
        dashBoard: {
            sectionTitleColor: "white",
            background: "transparent linear-gradient(180deg, #392E5E 0%, #161F40 100%) 0% 0% no-repeat padding-box",
            lineChart: {
                background: "transparent linear-gradient(214deg, #3E3D77 0%, #14234A 100%) 0% 0% no-repeat padding-box",
                svgBackground: "transparent linear-gradient(179deg, #0064A700 0%, #1C2A50 100%) 0% 0% no-repeat padding-box",
                currentPlayer: {
                    color: "#229FC4"
                },
                hoverPlayer: {
                    color: "#A50E93"
                }
            },
            maxCorrect: {
                background: "transparent linear-gradient(180deg, #392E5E 0%, #161F40 100%) 0% 0% no-repeat padding-box",
                highlightColor: "white"
            },
            gauge: {
                background: "transparent linear-gradient(180deg, #793A83A7 0%, #2F4666D0 100%) 0% 0% no-repeat padding-box",
                gaugeSVGPath: "/assets/dashboard/classic/gauge.svg",
                needleSVGPath: "/assets/dashboard/classic/needle.svg"
            },
            questionSummary: {
                background: "transparent linear-gradient(180deg, #38376E 0%, #18284B 100%) 0% 0% no-repeat padding-box",
                correct: {
                    answeredTextColor: "white",
                    backgroundColor: "#229FC4",
                },
                incorrect: {
                    answeredTextColor: "white",
                    backgroundColor: "#A50E93",
                },
            },
            streak: {
                fireSVGPath: "/assets/dashboard/classic/streak.svg",
                streakNumberColor: "#3584a5"
            },
            averageTime: {
                stopWatchSVGPath: "/assets/dashboard/classic/stopwatch.svg",
                host: {
                    background: "transparent linear-gradient(180deg, #3E69AC 0%, #2D94A2 100%) 0% 0% no-repeat padding-box",
                    timeColor: "white"
                },
                player: {
                    background: "transparent linear-gradient(180deg, #3E69AC 0%, #2D94A2 100%) 0% 0% no-repeat padding-box",
                    timeColor: "white"
                }
            }
        },
    },
    breakpoints: createBreakpoints({
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1367,
            xxl: 2000,
            xxxl: 3000,
        }
    }),
    color: createColors("#04304B", "#006DCA", "#E4E9EC", "#F44336"),
};
//# sourceMappingURL=classic.js.map